import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import { createBrandForm } from 'services/brands/duck';
import { push } from 'connected-react-router';
import EditBrandForm from 'components/organisms/forms/EditBrand';
import { getDefaultEnabledChannels } from 'helpers/channels';

class CreateEntityContainer extends Component {
    render() {
        return (
            <EditBrandForm
                handleSubmit={this.props.handleSubmit.bind(null, createBrandForm)}
                currentUser={this.props.currentUser}
                cancel={() => this.props.push('/admin/brands')} >
                {this.props.children}
            </EditBrandForm>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.users.currentUser
});

export default compose(
    connect(mapStateToProps, { push }),
    reduxForm({
        form: 'createBrand',
        enableReinitialize: true,
        initialValues: {
            meta: {
                channelConfig: getDefaultEnabledChannels()
            }
        }

    })
)(CreateEntityContainer);



// WEBPACK FOOTER //
// ./src/containers/forms/brands/CreateBrandContainer.js